/*
 *
 *  * Copyright (c) Funtip GbR 2018.
 *  * Simon Oldeboershuis, Perry Prust
 *
 */

import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { AlbumImage } from '../../Playlist/AlbumImage';
import { albumEditPath } from '../AlbumEdit';
import { loadAlbum } from '../AlbumEdit/actions';
import { albumByIdSelector } from '../AlbumEdit/selectors';

interface AlbumLinkProps extends React.PropsWithChildren{
    albumId: string;
    withImage?: boolean;
}

export const AlbumLink: React.FC<AlbumLinkProps> = props => {
    const dispatch = useDispatch();

    const album = useSelector(albumByIdSelector(props.albumId));

    React.useEffect(() => {
        if (props.albumId && !props.children) {
            dispatch(loadAlbum(props.albumId));
        }
    }, [dispatch, props.albumId, props.children]);

    if (!props?.albumId) {
        return null;
    }
    if (props.children) {
        return (
            <>
                <Link to={albumEditPath(props.albumId)}>{props.children}</Link>
            </>
        );
    } else {
        return (
            <>
                <Link to={albumEditPath(props.albumId)}>{album?.name}</Link>
                {props.withImage && (
                    <>
                        <br />
                        <AlbumImage imageId={album?.imageId} />
                    </>
                )}
            </>
        );
    }
};
